var _path, _path2, _line, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionTypeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85938 18.75H17.7761V17.3889L17.776 3.4375C17.2945 2.89096 16.1238 1.7982 15.5375 1.25099L15.5365 1.25H14.3646H5.69274C5.2325 1.25 4.85941 1.59822 4.85941 2.02778L4.85938 18.75Z",
    fill: "#34657F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3633 1.25V3.53125C14.3633 4.08353 14.811 4.53125 15.3633 4.53125H17.8789",
    stroke: "white",
    strokeWidth: 0.75
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.25,
    y1: 8.25,
    x2: 15,
    y2: 8.25,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.25,
    y1: 10.75,
    x2: 13.75,
    y2: 10.75,
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6.25,
    y1: 13.25,
    x2: 12.5,
    y2: 13.25,
    stroke: "white"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6.25,
    y1: 15.75,
    x2: 15,
    y2: 15.75,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionTypeIcon);
export default __webpack_public_path__ + "static/media/subscription-type-icon.14f8f28842d61c71f1c5424f36f2e254.svg";
export { ForwardRef as ReactComponent };